import type { PluginFunction } from '@kastjs/runtime-core';
import type { InnerOptions, KContext } from '../types';

type Params<F extends PluginFunction<any>> = Parameters<F>;

export interface AopOptions<F extends PluginFunction<any>> {
  before?: (context: KContext, params: Params<F>[1], options: InnerOptions) => Params<F>[1];
  after?: (context: KContext, params: Params<F>[1], options: InnerOptions) => void;
}

/**
 * api 工厂函数
 * @param func kast 插件函数
 * @param aopOptions 设置 kast 的切面
 */
export function aopFactory<F extends PluginFunction<any>>(func: F, aopOptions?: AopOptions<F>) {
  const { after, before } = aopOptions || {};

  return async function (context: KContext, params: Params<F>[1], options: InnerOptions) {
    if (typeof func !== 'function') return;

    // 执行前置逻辑，一般都是参数处理
    const resultParams = before?.(context, params, options) || params;

    // 执行kast插件逻辑
    await context.app.setup(func, resultParams);

    // 执行插件后置逻辑
    await after?.(context, params, options);

    return resultParams;
  };
}
